import API from "./API";
const sessionRenewApi = async () => {
  return await API.get(
    "/user/renew_session"
  )
    .then((res) => {
      sessionStorage.setItem("session_key", res.data.session_key);
   
    })
    .catch((e) => null);
};

export { sessionRenewApi }; 